import { render, staticRenderFns } from "./BlanketVOBTable.vue?vue&type=template&id=060f3ba2&scoped=true"
import script from "./BlanketVOBTable.vue?vue&type=script&lang=js"
export * from "./BlanketVOBTable.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBTable.vue?vue&type=style&index=0&id=060f3ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f3ba2",
  null
  
)

export default component.exports